import React, { useMemo } from "react";
import { useNavigateToTitle } from "../../hooks/useNavigateToTitle";
import { ReleaseCardModel } from "./HomeLandingModel";
import { releaseCardToAsset } from "../../mappers/releaseCardToAsset";

export default function ValuePickCard({ item }: { item: ReleaseCardModel }) {
  const navigateToTitle = useNavigateToTitle();
  const asset = useMemo(() => releaseCardToAsset(item), [item]);

  const durationPick = item.picks.find(
    (p) => p.label.toLowerCase() === "duration"
  );
  const metaParts = item.picks
    .filter((p) => p.label.toLowerCase() !== "duration")
    .map((p) => p.value)
    .filter(Boolean)
    .join(", ");

  const openTitle = () => {
    navigateToTitle(asset.id);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      openTitle();
    }
  };

  return (
    <div
      className="homeLandingVFMCard"
      role="button"
      tabIndex={0}
      onClick={openTitle}
      onKeyDown={handleKeyDown}
      aria-label={`Open ${item.title}`}
    >
      <div className="homeLandingVFMCardImageWrap">
        {item.thumbnailSrc ? (
          <img
            className="homeLandingVFMCardImage"
            src={item.thumbnailSrc}
            alt={item.title}
          />
        ) : (
          <div className="homeLandingVFMCardImagePlaceholder" />
        )}
        <div className="homeLandingVFMCardPriceBadgeContainer">
          {item.price && (
            <span className="homeLandingVFMCardPriceBadge">{item.price}</span>
          )}
          {durationPick && (
            <span className="homeLandingVFMCardDurationBadge">
              {durationPick.value}
            </span>
          )}
        </div>
      </div>

      {metaParts && (
        <div className="homeLandingVFMCardMeta">{metaParts}</div>
      )}
      <div className="homeLandingVFMCardTitle">{item.title}</div>
      {(item.description || item.subtitle) && (
        <p className="homeLandingVFMCardDescription">
          {item.description ?? item.subtitle}
        </p>
      )}
    </div>
  );
}
